import React, { lazy, Suspense } from 'react';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import useI18next from '../../hooks/useI18next';
import retry from '../utils/chunkRetry';

const LoadableRedux = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "editor_v3", webpackPrefetch: true */
        '../../redux/EditorModuleLoader'
      )
  )
);

const I18NextLoader = () => {
  useI18next();
  return null;
};

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * This is a wrapper that should be used in your preset
 */
const EditorLoadableWrapper: React.FC<Props> = ({ children, fallback }) => {
  const isMounted = useIsMounted();

  if (!isMounted) {
    return null; // never SSR
  }

  return (
    <ErrorBoundary debugComponent="EditorLoadableWrapper">
      <Suspense
        fallback={fallback === null ? fallback : (fallback ?? <LoadingIndicator view={'llama'} />)}
      >
        <I18NextLoader />
        <LoadableRedux />
        {children}
      </Suspense>
    </ErrorBoundary>
  );
};
EditorLoadableWrapper.displayName = 'EditorLoadableWrapper';

export default EditorLoadableWrapper;
